<template>
  <div class="index-number clearFloat">
    <template v-if="show">
      <template v-for="(item, index) in numberList">
        <ul class="number-wrap" :key="index" :style="{marginTop: - ($el.offsetHeight * item) + 'px'}">
          <li class="background" style="list-style: none;" v-for="num in 10" :key="'num-' + (num - 1)" :class="`number number-${num - 1}`" :style="{height: $el.offsetHeight + 'px'}">
            {{num - 1}}
          </li>
        </ul>
        <ul class="number-wrap dh" :key="'dh' + index" v-if="format && numberList.length - index > 3 && (numberList.length - index) % 3 === 1">
          <li>,</li>
        </ul>
      </template>
    </template>
  </div>
</template>

<script>
  export default {

    props: {
      value: Number,

      format: {
        type: Boolean,
        default (){
          return true;
        }
      }
    },

    data() {
      return {
        show: false
      }
    },

    mounted (){
      this.show = true;
    },

    computed: {
      numberList (){
        return this.value ? this.value.toString().split('').filter(item => item) : [0];
      }
    },

    methods: {

    },

    watch: {}
  };
</script>

<style lang="scss">
  .index-number {
    display: inline-block;
    height: 100%;
    overflow: hidden;
    & > .number-wrap{
      list-style: none;
      transition: margin-top 2s;
      float: left;

      & >.background{
        /*background: url("~@/assets/layout/background-border-pro.png") no-repeat;*/
        background-size:100% 100%;
        width: 70px;
        height: 100px;
      }

      & > .number{
        text-align: center;
        line-height: 1.4;
        font-family: HighlandGothicFLF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EvNumber.vue